import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import { Box, Modal, Stack, Card, CardContent, CardHeader, Button, ToggleButton, ToggleButtonGroup, Alert } from '@mui/material';
import { updateOrderAction } from '../../../../services/request';
import DownloadDocumentsModal from '../DownloadDocumentsModal';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const ChangeStateModal = ({ order, open, handleClose }) => {
  const [state, setState] = React.useState(order.state);
  const { loading, mutate, error } = useMutation(updateOrderAction);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [openDownloadModal, setOpenDownloadModal] = React.useState(false);

  const handleOpenDownloadModal = () => setOpenDownloadModal(true);
  const handleCloseDownloadModal = () => {
    setOpenDownloadModal(false);
    handleClose();
  };

  const handleChange = (event, newState) => {
    if (newState !== null) {
      setState(newState);
    }
  };

  const handleSubmit = async () => {
    const { error: mutateError, payload } = await mutate(order.id, { state });
    if (!mutateError) {
      if (order.way_of_sending_contract === 'traditional_mail' && state === 'CON') {
        handleOpenDownloadModal();
      } else {
        handleClose();
      }

    } else if (_.isArray(payload)) {
      setErrorMessage(payload[0]);
    } else {
      setErrorMessage('Nie udało się zmienić statusu');
    }
  };

  return (
    <>
      {!openDownloadModal
        ? <Modal open={open} onClose={handleClose} >
          <Card sx={{ ...style, width: '25vw' }}>
            <CardHeader
              title={`Zmień status zamówienia ${order.identifier}`}
              sx={{ textAlign: 'center' }}
            />
            <CardContent sx={{ textAlign: 'center' }}>
              <ToggleButtonGroup
                color="primary"
                orientation="vertical"
                value={state}
                exclusive
                onChange={handleChange}
              >
                {_.map(order.states, (state, code) => (
                  <ToggleButton key={code} value={code}>{state}</ToggleButton>
                ))}
              </ToggleButtonGroup>
              { error
                ? <>
                  <Box height={40}/>
                  <Alert variant="outlined" severity="error">{errorMessage}</Alert>
                </>
                : null}
              <Box height={40} />
              <Stack direction="row" justifyContent="space-around" alignItems="end" flexGrow={1}>
                <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>Anuluj</Button>
                <Button sx={{ flexGrow: 0.4 }} disabled={order.state === state || loading} variant="contained" onClick={handleSubmit}>Zmień status</Button>
              </Stack>
            </CardContent>
          </Card>
        </Modal>
        : <DownloadDocumentsModal order={order} open={openDownloadModal} handleClose={handleCloseDownloadModal} setOpenSnackbar={() => {}} setMessage={() => {}}/>}
    </>
  );
};


export default ChangeStateModal;
